import { QuestionCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import ModuleCard from 'components/cards/ModuleCard';
import { colors, space } from 'design';
import useSymptomTrackingData from 'hooks/useSymptomTrackingData';
import posthog from 'posthog-js';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  nextPeriodPredictionContainer: {
    width: 'fit-content',
    textAlign: 'center',
    position: 'relative',
  },
  nextPeriodDatesPrediction: {
    fontSize: 13,
    fontWeight: 500,
    color: colors.text.disabled,
    margin: 0,
  },
  nextPeriodDescription: {
    fontSize: 13,
    fontWeight: 500,
    color: colors.text.tertiary,
    margin: 0,
  },
  nextPeriodPrediction: {
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
  },
  periodPredictionHelpContainer: {
    position: 'absolute',
    top: 0,
    right: -24,
    '& svg': {
      color: colors.text.disabled,
    },
  },
});

const NextPeriodPrediction: React.FC = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const [showPeriodPredictionHelp, setShowPeriodPredictionHelp] = useState(false);
  const { nextPeriodPrediction, cycleStats } = useSymptomTrackingData();

  const { predictionLabel, predictionValue } = nextPeriodPrediction;

  return (
    <div className={styles.nextPeriodPredictionContainer}>
      <ModuleCard block={false} bodyStyle={{ padding: `${space['2xl']}px ${space['2xl']}px ${space.xl}px` }}>
        <h3 className={styles.nextPeriodDescription}>{predictionLabel}</h3>
        <p className={styles.nextPeriodPrediction}>{predictionValue}</p>
        <p className={styles.nextPeriodDatesPrediction}>
          {cycleStats.roundedStandardDeviation >= 1 && (
            <Trans
              i18nKey="symptomTracking.nextPeriod.plusMinusDays"
              values={{ plusMinusDays: cycleStats.roundedStandardDeviation }}
              count={cycleStats.roundedStandardDeviation}
            />
          )}
        </p>
      </ModuleCard>
      <div className={styles.periodPredictionHelpContainer}>
        <QuestionCircleOutlined
          data-testid="tracking.next-period-prediction.help"
          onClick={() => {
            setShowPeriodPredictionHelp(true);
            posthog.capture('tracking.period_prediction_help_opened');
          }}
        />
        <Modal
          open={showPeriodPredictionHelp}
          onCancel={() => setShowPeriodPredictionHelp(false)}
          footer={<span />}
          title={t('symptomTracking.nextPeriod.helpTitle')}
        >
          <p>
            <Trans i18nKey="symptomTracking.nextPeriod.help" components={{ br: <br /> }} />
          </p>
        </Modal>
      </div>
    </div>
  );
};

export default NextPeriodPrediction;
